import { createSlice, PayloadAction, Dispatch } from '@reduxjs/toolkit';
import { APIError } from 'models';
import type { RootState } from 'store/store';
import {
  Lwm2mDetailsSuccess,
  Lwm2mFilter,
  Lwm2mState,
  Lwm2mSuccess,
} from 'models/lwm2m';
import { findRegistrations } from 'services/lwm2mService/lwm2mService';

export const defaultState: Lwm2mState = {
  list: {
    data: null,
    totalCount: 0,
    isLoading: false,
    error: null,
    filters: {
      active: false,
      data: null,
    },
  },
  details: {
    logs: null,
    isLoading: false,
    error: null,
  },
};

// Export slice
export const lwm2mSlice = createSlice({
  name: 'lwm2m',
  initialState: defaultState,
  reducers: {
    getRegistrations: (state) => {
      state.list.isLoading = true;
      state.list.error = null;
    },
    getRegistrationsSuccess: (state, action: PayloadAction<Lwm2mSuccess>) => {
      state.list.isLoading = false;
      state.list.error = null;
      state.list.data = action.payload.response;
      state.list.totalCount = action.payload.totalCount;
      //state.list.filters.data = action.payload.filters;
    },
    getRegistrationsFailure: (state, action: PayloadAction<APIError>) => {
      state.list.data = [];
      state.list.totalCount = 0;
      state.list.isLoading = false;
      state.list.error = action.payload;
    },
    setLwm2mFilters: (state, action: PayloadAction<boolean>) => {
      state.list.filters.active = action.payload;
    },
    getLwm2mDetails: (state) => {
      state.details.isLoading = true;
      state.details.error = null;
    },
    getLwm2mDetailsSuccess: (
      state,
      action: PayloadAction<Lwm2mDetailsSuccess>
    ) => {
      state.details.isLoading = false;
      state.details.logs = action.payload.logs;
    },
    getLwm2mDetailsFailure: (state, action: PayloadAction<APIError>) => {
      state.details.logs = null;
      state.details.isLoading = false;
      state.details.error = action.payload;
    },
  },
});

// Export actions
export const {
  getRegistrations,
  getRegistrationsSuccess,
  getRegistrationsFailure,
  setLwm2mFilters,
  getLwm2mDetails,
  getLwm2mDetailsSuccess,
  getLwm2mDetailsFailure,
} = lwm2mSlice.actions;

// Export reducer
export const lwm2mReducer = lwm2mSlice.reducer;

export const lwm2mListSelector = (state: RootState) => state.lwm2m.list;

export const lwm2mDetailsSelector = (state: RootState) => state.lwm2m.details;

// Export thunk
export const fetchRegistrationList =
  (filter: Lwm2mFilter[], offset: number) => async (dispatch: Dispatch) => {
    console.log('Fetching registration list', { filter, offset });
    dispatch(getRegistrations());
    try {
      const response = await findRegistrations(filter);
      dispatch(
        getRegistrationsSuccess({
          response: response.data,
          totalCount: response.data.length,
          filters: response.data.length ? filter : null,
        })
      );
    } catch (e: any) {
      dispatch(getRegistrationsFailure(e));
    }
  };
